import { schema } from 'normalizr';

export const ENTITY_QBO_IMPORT_PROCESSES = 'quickbooksOnlineImportProcesses';
export const ENTITY_QBO_IMPORT_PROCESSES_LIST = 'quickbooksOnlineImportProcessesList';

export const qboImportProcessesSchema = new schema.Entity(ENTITY_QBO_IMPORT_PROCESSES);
export const qboImportProcessesListSchema = new schema.Entity(
  ENTITY_QBO_IMPORT_PROCESSES_LIST,
  { data: [qboImportProcessesSchema] },
  { idAttribute: () => 'list' },
);
